import vuex from '@/store'
const baseConfig = require('../../config/config')
const { publicPath } = baseConfig
const production = vuex.state.production // 是否生产
const protocolcheck = require('@/Tool/protocolcheck.js')

const config = [
  // 话术
  {
    name: 'srss',
    entry: `${production ? '' : '//localhost:7789'}/srss/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-srss',
    activeRule: publicPath + '/#/srss',
    props: {
      mainPrefix: publicPath,
      vuex,
    },
  },
  // 权限
  {
    name: 'uc',
    entry: `${production ? '' : '//localhost:7888'}/uc/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-uc',
    activeRule: publicPath + '/#/uc',
    props: {
      mainPrefix: publicPath,
      vuex,
    },
  },
  // 通话记录
  {
    name: 'scrm-call',
    entry: `${production ? '' : '//localhost:7790'}/scrm-call/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-call',
    activeRule: publicPath + '/#/scrm-call',
    props: {
      mainPrefix: publicPath,
      vuex,
    },
  },
  // crm
  {
    name: 'crm',
    entry: `${production ? '' : '//localhost:7788'}/crm/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-crm',
    activeRule: publicPath + '/#/crm',
    props: {
      mainPrefix: publicPath,
      vuex,
    },
  },
  // 小知识-知识模板
  {
    name: 'aivideo',
    entry: `${production ? '' : '//localhost:7999'}/aivideo/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-aivideo',
    activeRule: publicPath + '/#/aivideo',
    props: {
      mainPrefix: publicPath,
      vuex,
    },
  },
  // 数据中心
  {
    name: 'scrm-datacenter',
    entry: `${production ? '' : '//localhost:7790'}/scrm-datacenter/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-datacenter',
    activeRule: publicPath + '/#/scrm-datacenter',
    props: {
      mainPrefix: publicPath,
      vuex,
    },
  },
  // 口播项目
  {
    name: 'vshow',
    entry: `${production ? '' : '//localhost:9998'}/vshow/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-broadcast',
    activeRule: publicPath + '/#/vshow',
    props: {
      mainPrefix: publicPath,
      vuex,
      protocolcheck,
    },
  },
  // 直播项目
  {
    name: 'dh-live-room',
    entry: `${production ? '' : '//localhost:9797'}/dh-live-room/`, // 公司的平台地址需要把最后一个/写好
    container: '#app-live-room',
    activeRule: publicPath + '/#/dh-live-room',
    props: {
      mainPrefix: publicPath,
      vuex,
      protocolcheck,
    },
  },
]

export default config
